/*
 * @description:
 * @author: Jason Wong
 * @since: 2022-05-30 14:13:03
 */
import { addJumpTagDealer } from "./data";

/**
 * CAT
 */
addJumpTagDealer("cat-project", (router, jumpInfo) => {
  router.push({
    name: "projectDetail",
    query: {
      projectId: jumpInfo.params.get("proj-id"),
      activeTab: "tasks",
      _d_file_id: jumpInfo.params.get("file-id"),
    },
  });
});
addJumpTagDealer("cat-assignTask", (router, jumpInfo) => {
  router.push({
    name: "splitTask",
    query: {
      fileId: jumpInfo.params.get("file-id"),
      projectId: jumpInfo.params.get("proj-id"),
      workflow: jumpInfo.params.get("flow"),
      _d_task_id: jumpInfo.params.get("task-id") + "_" + jumpInfo.params.get("task-stage"),
    },
  });
});
addJumpTagDealer("cat-tasks", (router, jumpInfo) => {
  router.push({
    name: "myTaskList",
    query: {
      projectId: jumpInfo.params.get("proj-id"),
      activeTab: "tasks",
      _d_file_id: jumpInfo.params.get("file-id"),
      _d_task_item_id: jumpInfo.params.get("task-item-id"),
    },
  });
});
